export enum TeacherReportType {
  BASIC_PROGRESS = "basicProgress",
  BASIC_PROGRESS_FOR_ACCOUNT = "basicProgressForAccount",
  WRITING_PROGRESS = "writingProgress",
  DIAGNOSTIC_PROGRESS = "diagnosticProgress",
}
